module.exports = __webpack_public_path__ + "slide_noimage.svg?c91b35c671413350b00d9266726130a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slide_noimage.svg
// module id = 570
// module chunks = 0